import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useIntl } from 'react-intl';

export default function BibScreenReaderDescription({ bibBrief }) {
  const intl = useIntl();

  const title = bibBrief.get('title');
  const authors = bibBrief.get('authors');
  const formatId = bibBrief.get('format');

  const formatMessage = formatId ? intl.formatMessage({ id: `FORMAT.${formatId.toLowerCase()}` }) : '';
  const authorsMessage =
    (authors.size || authors.count()) &&
    intl.formatMessage(
      { id: 'by_authors' },
      {
        authorLinks: authors?.toJS().join(', ')
      }
    );

  return <>{[title, formatMessage, authorsMessage].filter(Boolean).join(', ')}</>;
}

BibScreenReaderDescription.propTypes = {
  bibBrief: ImmutablePropTypes.map
};
